<template>
  <v-app-bar dark color="blue">
    <v-toolbar-title
      ><img src="../../../../assets/logo.png" height="52px" style="margin-top: 10px"
    /></v-toolbar-title>
    <v-spacer></v-spacer>
    <!--v-btn @click="logout"> Logout </!--v-btn-->
  </v-app-bar>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "SystemBar",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ getAuth: "BFC/getAuth" }),
  },
  methods: {
    ...mapActions({
      signout: "BFC/logout",
    }),

    logout() {
      let redirectPath = "";
      let auth = this.getAuth;
      if (auth.authType == "Doctor") {
        redirectPath = "/doctor";
      } else if (auth.authType == "Admin") {
        redirectPath = "/admin";
      } else if (auth.authType == "Inspector") {
        redirectPath = "/inspector";
      } else {
        redirectPath = "/lab";
      }
      this.signout();
      this.$router.push(redirectPath);
    },
  },
};
</script>
